const navs = [
    { name: "labels.notifications", url: "/notifications/", icon: "trash-can" },
    { name: "labels.trash", url: "/notifications/trash/", icon: "trash-can" },
]

export default navs